/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface BookingControllerDownloadFinancialReport$Params {
  travel_id: number;
}

export function bookingControllerDownloadFinancialReport(http: HttpClient, rootUrl: string, params: BookingControllerDownloadFinancialReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerDownloadFinancialReport.PATH, 'get');
  if (params) {
    rb.path('travel_id', params.travel_id, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

bookingControllerDownloadFinancialReport.PATH = '/booking/travel/{travel_id}/xls-financial';
